let current = 0;
let droppedFiles = null;
let droppedFiles2 = null;
let phoneVerify;
let applicationFormStartedTracked = false;
let applicationFormCompletedTracked = false;

const form = document.getElementById('pro-form');
const formLabels = window.formLabels;
const qualification = document.getElementById('LEADCF7');
const sidebar = document.querySelectorAll('.step');
const steps = document.querySelectorAll('.form-step');

const MAX_FILES = 5;
const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB

// Address enforcement and helpers
const ADDRESS_CONTAINERS = {
  business: 'business-address-fields',
  trading: 'trading-address-fields'
};

const ALWAYS_REQUIRED = new Set([
  'Street',
  'City',
  'State',
  'Zip_Code',
  'LEADCF8'
]);

const TRADING_REQUIRED = new Set([
  'LEADCF11',
  'LEADCF12',
  'LEADCF13',
  'LEADCF14',
  'LEADCF15'
]);

document.addEventListener('DOMContentLoaded', () => {
  if (!form) return;

  loadSavedData();
  updateStep();
  sidebarToggle();
  sidebarClick();
  handleFileDragDrop();
  handleFileDragDrop2();
  phoneValidation();
  qualificationField();

  form.addEventListener('submit', handleFormSubmit);

  const businessCountry = document.getElementById('LEADCF8');

  if (businessCountry) {
    const toggleEori = () => {
      const wrapper = document.getElementById('eori-wrapper');

      if (!wrapper) return;

      const country = businessCountry.value;
      const isIreland = country === 'Ireland';

      wrapper.style.display = isIreland ? 'block' : 'none';

      if (!isIreland) {
        const eori = document.getElementById('LEADCF30');

        if (eori) {
          eori.value = '';
          clearError('LEADCF30');
        }
      }
    };

    businessCountry.addEventListener('change', toggleEori);
    toggleEori();
  }

  waitForGoogleMaps(initGoogleAddressAutocomplete);
});

/**
 * Sends an event through the existing Meta Pixel.
 *
 * fbq is provided by the Shopify Facebook & Instagram app after
 * the visitor has granted the required marketing consent.
 */
function publishMetaEvent(eventType, eventName, parameters = {}) {
  if (typeof window.fbq !== 'function') {
    console.info(
      `Meta event not sent because fbq is unavailable: ${eventName}`
    );

    return false;
  }

  window.fbq(eventType, eventName, parameters);

  // Remove after tracking has been fully tested.
  console.log(
    'Meta event sent:',
    eventType,
    eventName,
    parameters
  );

  return true;
}

/**
 * Returns whether the trading-address option is set to Yes.
 */
function isTradingYes() {
  return document.querySelector('#trading_address_yes:checked');
}

/**
 * Ensures the appropriate address container is visible.
 */
function ensureVisibleByField(id) {
  const businessFields = new Set([
    'Street',
    'City',
    'State',
    'Zip_Code',
    'LEADCF8',
    'autocomplete-address'
  ]);

  const tradingFields = new Set([
    'LEADCF11',
    'LEADCF12',
    'LEADCF13',
    'LEADCF14',
    'LEADCF15',
    'autocomplete-trading-address'
  ]);

  if (businessFields.has(id)) {
    document
      .getElementById(ADDRESS_CONTAINERS.business)
      ?.style.setProperty('display', 'block', 'important');
  }

  if (tradingFields.has(id)) {
    document
      .getElementById(ADDRESS_CONTAINERS.trading)
      ?.style.setProperty('display', 'block', 'important');

    const wrapper = document.getElementById(
      'trading_address_wrapper'
    );

    const yes = document.getElementById(
      'trading_address_yes'
    );

    if (wrapper) {
      wrapper.style.display = 'block';
    }

    if (yes) {
      yes.checked = true;
    }
  }
}

/**
 * Waits for Google Maps Places to load.
 */
function waitForGoogleMaps(callback, attempts = 0) {
  if (window.google?.maps?.places) {
    callback();
    return;
  }

  if (attempts >= 30) {
    console.error('Google Maps API failed to load in time.');
    return;
  }

  setTimeout(() => {
    waitForGoogleMaps(callback, attempts + 1);
  }, 100);
}

/**
 * Escapes HTML to prevent XSS from user input.
 */
function escapeHTML(text = '') {
  return text.replace(/[&<>"']/g, match => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  })[match]);
}

/**
 * Initializes Google address autocomplete.
 */
function initGoogleAddressAutocomplete() {
  const businessInput = document.getElementById(
    'autocomplete-address'
  );

  const tradingInput = document.getElementById(
    'autocomplete-trading-address'
  );

  if (businessInput) {
    setupAutocomplete(businessInput, {
      streetId: 'Street',
      cityId: 'City',
      stateId: 'State',
      zipId: 'Zip_Code',
      countrySelectId: 'LEADCF8',
      containerId: ADDRESS_CONTAINERS.business
    });
  }

  if (tradingInput) {
    setupAutocomplete(tradingInput, {
      streetId: 'LEADCF11',
      cityId: 'LEADCF13',
      stateId: 'LEADCF12',
      zipId: 'LEADCF14',
      countrySelectId: 'LEADCF15',
      containerId: ADDRESS_CONTAINERS.trading
    });
  }
}

/**
 * Runs Google address autocomplete for a search field.
 */
function setupAutocomplete(input, fieldMap) {
  const autocomplete = new google.maps.places.Autocomplete(
    input,
    {
      types: ['geocode']
    }
  );

  const container = fieldMap.containerId
    ? document.getElementById(fieldMap.containerId)
    : null;

  const anyFilled = [
    'streetId',
    'cityId',
    'stateId',
    'zipId'
  ].some(key => {
    const field = document.getElementById(fieldMap[key]);

    return field && field.value.trim() !== '';
  });

  if (container && anyFilled) {
    container.style.display = 'block';
  }

  if (container) {
    input.addEventListener('input', () => {
      const hasSearch = input.value.trim() !== '';

      const manualFilled = [
        'streetId',
        'cityId',
        'stateId',
        'zipId'
      ].some(key => {
        const field = document.getElementById(
          fieldMap[key]
        );

        return field && field.value.trim() !== '';
      });

      container.style.display =
        hasSearch || manualFilled
          ? 'block'
          : 'none';
    });
  }

  autocomplete.addListener('place_changed', () => {
    const place = autocomplete.getPlace();

    if (!place.address_components) return;

    const getComponent = type => {
      const component = place.address_components.find(item =>
        item.types.includes(type)
      );

      return component ? component.long_name : '';
    };

    const street = [
      getComponent('street_number'),
      getComponent('route')
    ]
      .filter(Boolean)
      .join(' ');

    const city =
      getComponent('locality') ||
      getComponent('postal_town');

    const state = getComponent(
      'administrative_area_level_1'
    );

    const postcode = getComponent('postal_code');
    const country = getComponent('country');

    const streetField = document.getElementById(
      fieldMap.streetId
    );

    const cityField = document.getElementById(
      fieldMap.cityId
    );

    const stateField = document.getElementById(
      fieldMap.stateId
    );

    const postcodeField = document.getElementById(
      fieldMap.zipId
    );

    if (streetField) {
      streetField.value = street;
    }

    if (cityField) {
      cityField.value = city;
    }

    if (stateField) {
      stateField.value = state;
    }

    if (postcodeField) {
      postcodeField.value = postcode;
    }

    const countrySelect = document.getElementById(
      fieldMap.countrySelectId
    );

    if (country && countrySelect) {
      for (const option of countrySelect.options) {
        if (
          option.text.trim().toLowerCase() ===
          country.toLowerCase()
        ) {
          countrySelect.value = option.value;

          countrySelect.dispatchEvent(
            new Event('change', {
              bubbles: true
            })
          );

          break;
        }
      }
    }

    if (container) {
      container.style.display = 'block';
    }

    [
      fieldMap.streetId,
      fieldMap.cityId,
      fieldMap.stateId,
      fieldMap.zipId,
      fieldMap.countrySelectId
    ].forEach(clearError);

    if (input.id === 'autocomplete-trading-address') {
      const wrapper = document.getElementById(
        'trading_address_wrapper'
      );

      const radio = document.getElementById(
        'trading_address_yes'
      );

      if (wrapper && radio) {
        wrapper.style.display = 'block';
        radio.checked = true;
      }
    }
  });
}

/**
 * Shows the additional qualification field when Other is selected.
 */
function qualificationField() {
  if (!qualification) return;

  const updateQualificationField = () => {
    const wrapper = document
      .getElementById('altQual')
      ?.closest('.field');

    if (!wrapper) return;

    wrapper.style.display =
      qualification.value === 'Other (please specify)'
        ? 'block'
        : 'none';
  };

  qualification.addEventListener(
    'change',
    updateQualificationField
  );

  updateQualificationField();
}

/**
 * Initializes international phone validation.
 */
function phoneValidation() {
  const input = document.getElementById('Phone');

  if (
    !input ||
    typeof window.intlTelInput !== 'function'
  ) {
    return;
  }

  phoneVerify = window.intlTelInput(input, {
    initialCountry: 'gb',
    preferredCountries: ['gb', 'ie'],

    geoIpLookup: callback => {
      fetch('https://ipapi.co/json')
        .then(response => {
          if (!response.ok) {
            throw new Error(
              `IP lookup failed: ${response.status}`
            );
          }

          return response.json();
        })
        .then(data => {
          callback(data.country_code || 'gb');
        })
        .catch(() => {
          callback('gb');
        });
    },

    utilsScript: 'intlTelInput-utils.js'
  });

  input.addEventListener('blur', () => {
    if (!phoneVerify?.isValidNumber()) {
      showError('Phone', formLabels.errorPhone);
      return;
    }

    clearError('Phone');
    input.value = phoneVerify.getNumber();
  });

  const itiContainer = document.querySelector(
    '.iti--allow-dropdown'
  );

  if (itiContainer?.nextElementSibling) {
    itiContainer.appendChild(
      itiContainer.nextElementSibling
    );
  }
}

/**
 * Toggles the sidebar dropdown on mobile.
 */
function sidebarToggle() {
  const toggleButton = document.getElementById(
    'sidebar-toggle'
  );

  toggleButton?.addEventListener('click', () => {
    const content = document.getElementById(
      'sidebar-container'
    );

    if (!content) return;

    if (content.classList.contains('open')) {
      content.classList.remove('open');

      setTimeout(() => {
        content.classList.add('hidden');
      }, 300);

      return;
    }

    content.classList.remove('hidden');

    setTimeout(() => {
      content.classList.add('open');
    }, 10);
  });
}

/**
 * Updates the form steps and sidebar indicators.
 */
function updateStep() {
  steps.forEach((step, index) => {
    step.classList.toggle('active', index === current);
  });

  sidebar.forEach((step, index) => {
    step.classList.remove(
      'active',
      'completed',
      'inactive'
    );

    step.classList.add(
      index === current
        ? 'active'
        : index < current
          ? 'completed'
          : 'inactive'
    );
  });

  window.scrollTo({
    top: 95,
    behavior: 'smooth'
  });
}

/**
 * Enables navigation to completed sidebar steps.
 */
function sidebarClick() {
  sidebar.forEach((step, index) => {
    step.addEventListener('click', () => {
      if (!step.classList.contains('completed')) return;

      current = index;
      updateStep();
    });
  });

  form?.addEventListener('keydown', event => {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  });
}

/**
 * Shows or hides an input wrapper based on a radio selection.
 */
function toggleVisibility(radioName, wrapperId) {
  const isChecked =
    document.querySelector(
      `input[name="${radioName}"]:checked`
    )?.value === 'Yes';

  const wrapper = document.getElementById(wrapperId);

  if (!wrapper) return;

  wrapper.style.display = isChecked
    ? 'block'
    : 'none';

  if (isChecked) return;

  const fields = wrapper.querySelectorAll(
    'input, select'
  );

  fields.forEach(field => {
    if (
      field.type === 'checkbox' ||
      field.type === 'radio'
    ) {
      field.checked = false;
    } else {
      field.value = '';
    }

    if (field.id) {
      clearError(field.id);
    }
  });
}

/**
 * Displays an error and highlights the invalid field.
 */
function showError(id, message) {
  const field = document.getElementById(id);
  const error = document.getElementById(
    `${id}Error`
  );

  const target =
    id === 'docUpload' || id === 'docUpload2'
      ? field?.parentElement
      : field;

  if (target) {
    target.style.borderColor = '#ef3427';
  }

  if (error && message) {
    error.style.display = 'block';
    error.textContent = message;
  }

  if (field) {
    const clear = () => clearError(id);

    field.addEventListener(
      'input',
      clear,
      { once: true }
    );

    field.addEventListener(
      'change',
      clear,
      { once: true }
    );
  }
}

/**
 * Clears a field's error state.
 */
function clearError(id) {
  const field = document.getElementById(id);
  const error = document.getElementById(
    `${id}Error`
  );

  const target =
    id === 'docUpload' || id === 'docUpload2'
      ? field?.parentElement
      : field;

  if (target) {
    target.style.borderColor = '';
  }

  if (error) {
    error.style.display = 'none';
    error.textContent = '';
  }
}

/**
 * Validates a collection of form fields.
 */
function validateSimple(ids) {
  let valid = true;

  const URL_FIELDS = new Set([
    'Website',
    'LEADCF10',
    'LEADCF27',
    'LEADCF23',
    'LEADCF26'
  ]);

  for (const id of ids) {
    clearError(id);

    const field = document.getElementById(id);

    if (id === 'docUpload') {
      const hasInput = field?.files?.length > 0;

      if (!droppedFiles && !hasInput) {
        showError(id, formLabels.errorFile);
        valid = false;
      }

      continue;
    }

    if (id === 'docUpload2') {
      const hasInput = field?.files?.length > 0;

      if (!droppedFiles2 && !hasInput) {
        showError(id, formLabels.errorFile);
        valid = false;
      }

      continue;
    }

    if (!field) continue;

    // EORI is required only when the business country is Ireland.
    if (id === 'LEADCF30') {
      const country = document.getElementById(
        'LEADCF8'
      )?.value;

      if (country === 'Ireland') {
        const value = field.value?.trim() || '';

        if (!value) {
          showError(id, formLabels.errorField);
          valid = false;
        }
      }

      continue;
    }

    const hidden = field.offsetParent === null;
    const tradingEnabled = Boolean(isTradingYes());

    const isRequiredWhenHidden =
      ALWAYS_REQUIRED.has(id) ||
      (
        tradingEnabled &&
        TRADING_REQUIRED.has(id)
      );

    if (hidden && isRequiredWhenHidden) {
      ensureVisibleByField(id);
    }

    if (hidden && !isRequiredWhenHidden) {
      continue;
    }

    const value = field.value?.trim() || '';

    // Optional URL fields are validated only when populated.
    if (URL_FIELDS.has(id)) {
      if (!value) continue;

      let urlToTest = value;

      if (!/^https?:\/\//i.test(urlToTest)) {
        urlToTest = `https://${urlToTest}`;
      }

      let isValidUrl = true;

      try {
        const parsedUrl = new URL(urlToTest);

        if (
          !parsedUrl.hostname ||
          !parsedUrl.hostname.includes('.')
        ) {
          isValidUrl = false;
        }
      } catch (error) {
        isValidUrl = false;
      }

      if (!isValidUrl) {
        showError(id, formLabels.errorUrl);
        valid = false;
        continue;
      }

      field.value = urlToTest;
      continue;
    }

    const isEmptyCountry =
      (
        id === 'LEADCF8' ||
        id === 'LEADCF15'
      ) &&
      (
        !value ||
        value === '---'
      );

    if (!value || isEmptyCountry) {
      showError(id, formLabels.errorField);
      valid = false;
      continue;
    }

    // Street addresses must contain at least one number.
    if (
      (
        id === 'Street' ||
        id === 'LEADCF11'
      ) &&
      !/\d/.test(value)
    ) {
      showError(id, formLabels.errorStreet);
      valid = false;
      continue;
    }

    if (id === 'Address_Confirm') {
      if (!field.checked) {
        showError(
          id,
          formLabels.errorAddressCorrect
        );

        valid = false;
      }

      continue;
    }

    if (
      id === 'Email' &&
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
    ) {
      showError(id, formLabels.errorEmail);
      valid = false;
      continue;
    }

    if (id === 'Confirm_Email') {
      const emailValue =
        document
          .getElementById('Email')
          ?.value.trim() || '';

      if (value !== emailValue) {
        showError(
          id,
          formLabels.errorEmailMatch
        );

        valid = false;
      }

      continue;
    }

    if (
      id === 'Phone' &&
      (
        !phoneVerify ||
        !phoneVerify.isValidNumber()
      )
    ) {
      showError(id, formLabels.errorPhone);
      valid = false;
      continue;
    }

    if (
      id === 'Zip_Code' ||
      id === 'LEADCF14'
    ) {
      const country = document.getElementById(
        id === 'LEADCF14'
          ? 'LEADCF15'
          : 'LEADCF8'
      )?.value;

      const ukRegex =
        /^([A-Z]{1,2}[0-9][0-9A-Z]? ?[0-9][A-Z]{2})$/i;

      const irelandRegex =
        /^[A-Z]\d[A-Z\d]\s?[0-9A-Z]{4}$/i;

      if (
        country === 'United Kingdom' &&
        !ukRegex.test(value)
      ) {
        showError(
          id,
          formLabels.errorPostCode
        );

        valid = false;
      }

      if (
        country === 'Ireland' &&
        !irelandRegex.test(value)
      ) {
        showError(
          id,
          formLabels.errorIrishPostCode
        );

        valid = false;
      }
    }
  }

  // Address entry guard rails for the business-details step.
  if (current === 1) {
    const businessManualIds = [
      'Street',
      'City',
      'State',
      'Zip_Code',
      'LEADCF8'
    ];

    const tradingManualIds = [
      'LEADCF11',
      'LEADCF12',
      'LEADCF13',
      'LEADCF14',
      'LEADCF15'
    ];

    const businessInput = document.getElementById(
      'autocomplete-address'
    );

    const tradingInput = document.getElementById(
      'autocomplete-trading-address'
    );

    const businessManualFilled = isAddressFilled(
      businessManualIds
    );

    const tradingManualFilled = isAddressFilled(
      tradingManualIds
    );

    const tradingAddressShown = Boolean(
      isTradingYes()
    );

    if (
      !businessManualFilled &&
      !businessInput?.value.trim()
    ) {
      ensureVisibleByField('autocomplete-address');

      showError(
        'autocomplete-address',
        formLabels.errorField ||
          'Please select a business address'
      );

      valid = false;
    }

    if (
      tradingAddressShown &&
      !tradingManualFilled &&
      !tradingInput?.value.trim()
    ) {
      ensureVisibleByField(
        'autocomplete-trading-address'
      );

      showError(
        'autocomplete-trading-address',
        formLabels.errorField ||
          'Please select a trading address'
      );

      valid = false;
    }
  }

  return valid;
}

/**
 * Returns whether at least one field in an address is populated.
 */
function isAddressFilled(fieldIds) {
  return fieldIds.some(id => {
    const field = document.getElementById(id);

    return field && field.value.trim();
  });
}

/**
 * Navigates to the previous form step.
 */
function prevStep() {
  if (current <= 0) return;

  current--;
  updateStep();
}

/**
 * Validates the current step and advances to the next one.
 *
 * ApplicationFormStarted fires once after the first page passes
 * validation and the customer clicks Next.
 */
function nextStep() {
  const validateMap = {
    0: [
      'First_Name',
      'Last_Name',
      'Email',
      'Confirm_Email',
      'Phone'
    ],
    1: [
      'Company',
      'LEADCF3',
      'LEADCF29',
      'LEADCF5',
      'LEADCF9',
      'Street',
      'City',
      'State',
      'Zip_Code',
      'LEADCF8',
      'LEADCF11',
      'LEADCF12',
      'LEADCF13',
      'LEADCF14',
      'LEADCF15',
      'No_of_Employees',
      'Address_Confirm',
      'LEADCF30'
    ],
    2: [
      'Website',
      'LEADCF10',
      'LEADCF27',
      'LEADCF23',
      'LEADCF26'
    ],
    3: [
      'LEADCF7',
      'altQual',
      'LEADCF20',
      'docUpload'
    ]
  };

  const completedStep = current;

  if (
    validateMap[completedStep] &&
    !validateSimple(validateMap[completedStep])
  ) {
    return;
  }

  saveStepData(completedStep);

  if (
    completedStep === 0 &&
    !applicationFormStartedTracked
  ) {
    const eventSent = publishMetaEvent(
      'trackCustom',
      'ApplicationFormStarted',
      {
        form_name: 'Pro Application Form',
        form_id: 'pro-form',
        completed_step: 1
      }
    );

    if (eventSent) {
      applicationFormStartedTracked = true;
    }
  }

  current = Math.min(
    current + 1,
    steps.length - 1
  );

  updateStep();

  if (current === 4) {
    requestAnimationFrame(generateReview);
  }
}

/**
 * Navigates directly to a specific step.
 */
function goToStep(stepIndex) {
  if (
    !Number.isInteger(stepIndex) ||
    stepIndex < 0 ||
    stepIndex >= steps.length
  ) {
    return;
  }

  current = stepIndex;
  updateStep();
}

/**
 * Saves data from a form step to local storage.
 */
function saveStepData(stepIndex) {
  if (!form) return;

  const step = steps[stepIndex];

  if (!step) return;

  const fields = Array.from(form.elements).filter(
    element =>
      element.closest('.form-step') === step &&
      element.name
  );

  const data = {};

  fields.forEach(input => {
    if (
      input.id === 'autocomplete-address' ||
      input.id === 'autocomplete-trading-address'
    ) {
      return;
    }

    if (
      input.type === 'checkbox' ||
      input.type === 'radio'
    ) {
      data[input.id] = input.checked;
    } else {
      data[input.id] = input.value;
    }
  });

  localStorage.setItem(
    `formStep${stepIndex}`,
    JSON.stringify(data)
  );
}

/**
 * Loads saved form data from local storage.
 */
function loadSavedData() {
  steps.forEach((step, index) => {
    const storedData = localStorage.getItem(
      `formStep${index}`
    );

    if (!storedData) return;

    let values;

    try {
      values = JSON.parse(storedData);
    } catch (error) {
      console.warn(
        `Could not parse saved form step ${index}:`,
        error
      );

      return;
    }

    Object.keys(values).forEach(id => {
      const field = document.getElementById(id);

      if (!field || field.type === 'file') return;

      if (
        field.type === 'checkbox' ||
        field.type === 'radio'
      ) {
        field.checked = Boolean(values[id]);

        field.dispatchEvent(
          new Event('change', {
            bubbles: true
          })
        );
      } else {
        field.value = values[id];

        field.dispatchEvent(
          new Event('input', {
            bubbles: true
          })
        );

        field.dispatchEvent(
          new Event('change', {
            bubbles: true
          })
        );
      }
    });
  });
}

/**
 * Clears saved form data.
 */
function clearSavedFormData() {
  steps.forEach((_, index) => {
    localStorage.removeItem(
      `formStep${index}`
    );
  });
}

/**
 * Sets up the first drag-and-drop file field.
 */
function handleFileDragDrop() {
  const dropArea = document.getElementById('dropArea');
  const fileInput = document.getElementById('docUpload');
  const fileNames = document.getElementById('fileNames');

  if (!dropArea || !fileInput || !fileNames) return;

  ['dragenter', 'dragover'].forEach(eventName => {
    dropArea.addEventListener(eventName, event => {
      event.preventDefault();
      dropArea.classList.add('dragover');
    });
  });

  ['dragleave', 'drop'].forEach(eventName => {
    dropArea.addEventListener(eventName, event => {
      event.preventDefault();
      dropArea.classList.remove('dragover');
    });
  });

  dropArea.addEventListener('drop', event => {
    droppedFiles = event.dataTransfer.files;

    fileNames.innerHTML = renderFileListHTML(
      droppedFiles
    );

    attachClearListener();
  });

  fileInput.addEventListener('change', () => {
    droppedFiles = null;

    fileNames.innerHTML = renderFileListHTML(
      fileInput.files
    );

    attachClearListener();
  });
}

/**
 * Sets up the second drag-and-drop file field.
 */
function handleFileDragDrop2() {
  const dropArea = document.getElementById('dropArea2');
  const fileInput = document.getElementById('docUpload2');
  const fileNames = document.getElementById('fileNames2');

  if (!dropArea || !fileInput || !fileNames) return;

  ['dragenter', 'dragover'].forEach(eventName => {
    dropArea.addEventListener(eventName, event => {
      event.preventDefault();
      dropArea.classList.add('dragover');
    });
  });

  ['dragleave', 'drop'].forEach(eventName => {
    dropArea.addEventListener(eventName, event => {
      event.preventDefault();
      dropArea.classList.remove('dragover');
    });
  });

  dropArea.addEventListener('drop', event => {
    droppedFiles2 = event.dataTransfer.files;

    fileNames.innerHTML = renderFileListHTML2(
      droppedFiles2
    );

    attachClearListener2();
  });

  fileInput.addEventListener('change', () => {
    droppedFiles2 = null;

    fileNames.innerHTML = renderFileListHTML2(
      fileInput.files
    );

    attachClearListener2();
  });
}

/**
 * Renders the first file-list preview.
 */
function renderFileListHTML(files) {
  const types = window.formValidTypes || {};
  const validFiles = [];

  const list = [...files].map(file => {
    let icon = types[file.type] || types.error;
    let errorMessage = '';

    if (!types[file.type]) {
      errorMessage = 'Invalid file type';
      icon = types.error;
    } else if (file.size > MAX_FILE_SIZE) {
      errorMessage =
        `File too large (${(
          file.size /
          1024 /
          1024
        ).toFixed(1)} MB)`;

      icon = types.error;
    } else if (validFiles.length >= MAX_FILES) {
      errorMessage =
        `Too many files (max ${MAX_FILES})`;

      icon = types.error;
    }

    if (!errorMessage) {
      validFiles.push(file);
    }

    return `
      <div class="file-item ${errorMessage ? 'error' : ''}">
        <img src="${icon || ''}" alt="">
        <span>${escapeHTML(file.name)}</span>
        ${
          errorMessage
            ? `<div class="file-error">${errorMessage}</div>`
            : ''
        }
      </div>
    `;
  }).join('');

  droppedFiles =
    validFiles.length > 0
      ? validFiles
      : null;

  if (validFiles.length > 0) {
    document
      .getElementById('dropArea')
      ?.classList.add('hidden');
  }

  return `
    <div class="file-list">${list}</div>
    <button
      type="button"
      class="clear-btn link"
      id="clearFilesBtn"
    >
      Remove files
    </button>
  `;
}

/**
 * Renders the second file-list preview.
 */
function renderFileListHTML2(files) {
  const types = window.formValidTypes || {};
  const validFiles = [];

  const list = [...files].map(file => {
    let icon = types[file.type] || types.error;
    let errorMessage = '';

    if (!types[file.type]) {
      errorMessage = 'Invalid file type';
      icon = types.error;
    } else if (file.size > MAX_FILE_SIZE) {
      errorMessage =
        `File too large (${(
          file.size /
          1024 /
          1024
        ).toFixed(1)} MB)`;

      icon = types.error;
    } else if (validFiles.length >= MAX_FILES) {
      errorMessage =
        `Too many files (max ${MAX_FILES})`;

      icon = types.error;
    }

    if (!errorMessage) {
      validFiles.push(file);
    }

    return `
      <div class="file-item ${errorMessage ? 'error' : ''}">
        <img src="${icon || ''}" alt="">
        <span>${escapeHTML(file.name)}</span>
        ${
          errorMessage
            ? `<div class="file-error">${errorMessage}</div>`
            : ''
        }
      </div>
    `;
  }).join('');

  droppedFiles2 =
    validFiles.length > 0
      ? validFiles
      : null;

  if (validFiles.length > 0) {
    document
      .getElementById('dropArea2')
      ?.classList.add('hidden');
  }

  return `
    <div class="file-list">${list}</div>
    <button
      type="button"
      class="clear-btn link"
      id="clearFilesBtn2"
    >
      Remove files
    </button>
  `;
}

/**
 * Attaches the first remove-files listener.
 */
function attachClearListener() {
  document
    .getElementById('clearFilesBtn')
    ?.addEventListener('click', clearFiles);
}

/**
 * Attaches the second remove-files listener.
 */
function attachClearListener2() {
  document
    .getElementById('clearFilesBtn2')
    ?.addEventListener('click', clearFiles2);
}

/**
 * Clears the first file input.
 */
function clearFiles() {
  const fileInput = document.getElementById('docUpload');
  const fileNames = document.getElementById('fileNames');

  if (!fileInput || !fileNames) return;

  droppedFiles = null;
  fileInput.value = '';
  fileNames.innerHTML = '';

  document
    .getElementById('dropArea')
    ?.classList.remove('hidden');

  clearError('docUpload');
}

/**
 * Clears the second file input.
 */
function clearFiles2() {
  const fileInput = document.getElementById('docUpload2');
  const fileNames = document.getElementById('fileNames2');

  if (!fileInput || !fileNames) return;

  droppedFiles2 = null;
  fileInput.value = '';
  fileNames.innerHTML = '';

  document
    .getElementById('dropArea2')
    ?.classList.remove('hidden');

  clearError('docUpload2');
}

/**
 * Populates the review section.
 */
function generateReview() {
  const getValue = id => {
    return document.getElementById(id)?.value.trim() || null;
  };

  const getRadio = name => {
    return (
      document.querySelector(
        `input[name="${name}"]:checked`
      )?.value || null
    );
  };

  const radioNames = new Set([
    'registered_company_radio',
    'vat_registered_radio',
    'employees_radio',
    'trading_name_radio',
    'trading_address_radio'
  ]);

  const get = id => {
    if (radioNames.has(id)) {
      return getRadio(id);
    }

    const value = getValue(id);

    return value
      ? escapeHTML(value)
      : null;
  };

  const reviewLine = (label, value) => {
    return value
      ? `<p><span class="caption">${label}:</span> ${value}</p>`
      : '';
  };

  const joinAddress = ids => {
    const parts = ids.map(get).filter(Boolean);

    return parts.length
      ? parts.join('<br>')
      : null;
  };

  const sections = [
    {
      title: formLabels.sectionTitle0,
      editStep: 0,
      fields: [
        {
          label: formLabels.name,
          value: () => [
            get('First_Name'),
            get('Last_Name')
          ].filter(Boolean).join(' ')
        },
        {
          label: formLabels.email,
          value: () => get('Email')
        },
        {
          label: formLabels.phone,
          value: () => get('Phone')
        },
        {
          label: formLabels.marketing,
          value: () =>
            document.getElementById('LEADCF101')?.checked
              ? 'Yes'
              : null
        }
      ]
    },
    {
      title: formLabels.sectionTitle1,
      editStep: 1,
      fields: [
        {
          label: formLabels.businessType,
          value: () => get('LEADCF5')
        },
        {
          label: formLabels.businessName,
          value: () => get('Company')
        },
        {
          label: formLabels.employeesQuestion,
          value: () => get('employees_radio')
        },
        {
          label: formLabels.noOfEmployees,
          value: () => get('No_of_Employees')
        },
        {
          label: formLabels.registeredCompany,
          value: () => get('registered_company_radio')
        },
        {
          label: formLabels.companyNo,
          value: () => get('LEADCF3')
        },
        {
          label: formLabels.vatRadio,
          value: () => get('vat_registered_radio')
        },
        {
          label: formLabels.vatNumber,
          value: () => get('LEADCF29')
        },
        {
          label: formLabels.tradingNameRadio,
          value: () => get('trading_name_radio')
        },
        {
          label: formLabels.tradingName,
          value: () => get('LEADCF9')
        },
        {
          label: formLabels.tradingAddressRadio,
          value: () => get('trading_address_radio')
        },
        {
          label: formLabels.tradingAddress,
          value: () => joinAddress([
            'LEADCF11',
            'LEADCF12',
            'LEADCF13',
            'LEADCF14',
            'LEADCF15'
          ])
        },
        {
          label: formLabels.businessAddress,
          value: () => joinAddress([
            'Street',
            'City',
            'State',
            'Zip_Code',
            'LEADCF8'
          ])
        },
        {
          label: formLabels.eoriNumber,
          value: () => get('LEADCF30')
        }
      ]
    },
    {
      title: formLabels.sectionTitle2,
      editStep: 2,
      fields: [
        {
          label: formLabels.website,
          value: () => get('Website')
        },
        {
          label: formLabels.instagram,
          value: () => get('LEADCF10')
        },
        {
          label: formLabels.facebook,
          value: () => get('LEADCF27')
        },
        {
          label: formLabels.tiktok,
          value: () => get('LEADCF23')
        },
        {
          label: formLabels.booking,
          value: () => get('LEADCF26')
        },
        {
          label: formLabels.hearAboutUs,
          value: () => get('LEADCF28')
        }
      ]
    },
    {
      title: formLabels.sectionTitle3,
      editStep: 3,
      fields: [
        {
          label: formLabels.qualification,
          value: () => get('LEADCF7')
        },
        {
          label: formLabels.altQualification,
          value: () => get('altQual')
        },
        {
          label: formLabels.awardingBody,
          value: () => get('LEADCF20')
        },
        {
          label: formLabels.uploadFiles,
          value: () => {
            const files =
              droppedFiles ||
              document.getElementById('docUpload')?.files;

            return files?.length
              ? renderFileListHTML(files)
              : null;
          }
        },
        {
          label: formLabels.uploadFiles2,
          value: () => {
            const files =
              droppedFiles2 ||
              document.getElementById('docUpload2')?.files;

            return files?.length
              ? renderFileListHTML2(files)
              : null;
          }
        },
        {
          label: formLabels.cibtac,
          value: () =>
            document.getElementById('LEADCF103')?.checked
              ? 'Yes'
              : null
        }
      ]
    }
  ];

  const reviewHTML = sections.map(section => {
    const content = section.fields
      .map(field =>
        reviewLine(field.label, field.value())
      )
      .filter(Boolean)
      .join('');

    if (!content) return '';

    return `
      <details class="review-accordion" open>
        <summary
          class="section-title h6"
          role="button"
        >
          ${section.title}

          <button
            class="link"
            type="button"
            onclick="event.stopPropagation(); goToStep(${section.editStep})"
          >
            Edit
          </button>

          <svg
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            focusable="false"
            class="icon icon-plus icon-caret"
            fill="none"
            viewBox="0 0 10 10"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z"
              fill="currentColor"
            ></path>
          </svg>

          <svg
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            focusable="false"
            class="icon icon-minus"
            fill="none"
            viewBox="0 0 10 2"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z"
              fill="currentColor"
            ></path>
          </svg>
        </summary>

        <div class="review-content">
          ${content}
        </div>
      </details>
    `;
  }).join('');

  const reviewSection = document.getElementById(
    'reviewSection'
  );

  if (reviewSection) {
    reviewSection.innerHTML = reviewHTML;
  }
}

/**
 * Sends qualification files to the Air Parser webhook.
 */
function webhookAirParser() {
  if (!droppedFiles?.length) return;

  const webhookData = new FormData();

  const email = document
    .getElementById('Email')
    ?.value.trim();

  const awardingBody = document
    .getElementById('LEADCF20')
    ?.value.trim();

  if (email) {
    webhookData.append('email', email);
  }

  if (awardingBody) {
    webhookData.append(
      'awardingBody',
      awardingBody
    );
  }

  droppedFiles.forEach(file => {
    webhookData.append('theFile', file);
  });

  webhookData.append('type', 'Lead');

  fetch(
    'https://hook.eu2.make.com/8dpliru7c6xs4n9ostiy4mk1ei652ekv',
    {
      method: 'POST',
      body: webhookData
    }
  )
    .then(response => {
      if (!response.ok) {
        throw new Error(
          `Webhook failed (${response.status})`
        );
      }
    })
    .catch(error => {
      console.warn('Webhook error:', error);
    });
}

/**
 * Hashes a value with SHA-256.
 */
async function sha256(value) {
  if (!value) return '';

  if (!window.crypto?.subtle) {
    console.warn(
      'crypto.subtle is unavailable; skipping hashing.'
    );

    return '';
  }

  const encoder = new TextEncoder();
  const data = encoder.encode(value);

  const hashBuffer = await window.crypto.subtle.digest(
    'SHA-256',
    data
  );

  const hashArray = Array.from(
    new Uint8Array(hashBuffer)
  );

  return hashArray
    .map(byte => byte.toString(16).padStart(2, '0'))
    .join('');
}

/**
 * Sends normalized and hashed form data to GTM.
 */
async function dataLayerFormSubmit() {
  window.dataLayer = window.dataLayer || [];

  const getValue = id => {
    return document.getElementById(id)?.value.trim() || '';
  };

  const getSelectText = id => {
    const select = document.getElementById(id);

    if (!select) return '';

    const option = select.options[select.selectedIndex];

    return option ? option.text.trim() : '';
  };

  const normalizeEmail = email =>
    email.trim().toLowerCase();

  const normalizeName = name =>
    name.trim().toLowerCase();

  const normalizeAddressValue = value =>
    value.trim().toLowerCase();

  const normalizePostcode = value =>
    value.trim().toLowerCase();

  const normalizePhone = phone =>
    phone.replace(/[^0-9]/g, '');

  const firstNameRaw = getValue('First_Name');
  const lastNameRaw = getValue('Last_Name');
  const emailRaw = getValue('Email');

  const phoneRaw =
    phoneVerify?.getNumber() ||
    getValue('Phone');

  const streetRaw = getValue('Street');
  const cityRaw = getValue('City');
  const regionRaw = getValue('State');
  const postalCodeRaw = getValue('Zip_Code');
  const countryRaw = getSelectText('LEADCF8');

  const firstNameNormalized =
    normalizeName(firstNameRaw);

  const lastNameNormalized =
    normalizeName(lastNameRaw);

  const emailNormalized =
    normalizeEmail(emailRaw);

  const phoneNormalized =
    normalizePhone(phoneRaw);

  const streetNormalized =
    normalizeAddressValue(streetRaw);

  const cityNormalized =
    normalizeAddressValue(cityRaw);

  const regionNormalized =
    normalizeAddressValue(regionRaw);

  const postalCodeNormalized =
    normalizePostcode(postalCodeRaw);

  const countryNormalized =
    countryRaw.trim().toLowerCase();

  const [
    hashedFirstName,
    hashedLastName,
    hashedEmail,
    hashedPhone,
    hashedCity,
    hashedRegion,
    hashedPostalCode,
    hashedStreet,
    hashedCountry
  ] = await Promise.all([
    sha256(firstNameNormalized),
    sha256(lastNameNormalized),
    sha256(emailNormalized),
    sha256(phoneNormalized),
    sha256(cityNormalized),
    sha256(regionNormalized),
    sha256(postalCodeNormalized),
    sha256(streetNormalized),
    sha256(countryNormalized)
  ]);

  const userData = {
    first_name: firstNameRaw || undefined,
    last_name: lastNameRaw || undefined,
    email: emailRaw || undefined,
    phone_number: phoneRaw || undefined,
    city: cityRaw || undefined,
    region: regionRaw || undefined,
    postal_code: postalCodeRaw || undefined,
    street: streetRaw || undefined,
    country: countryRaw || undefined,

    sha256_hashed_first_name:
      hashedFirstName || undefined,

    sha256_hashed_last_name:
      hashedLastName || undefined,

    sha256_hashed_email:
      hashedEmail || undefined,

    sha256_hashed_phone:
      hashedPhone || undefined,

    sha256_hashed_city:
      hashedCity || undefined,

    sha256_hashed_region:
      hashedRegion || undefined,

    sha256_hashed_postal_code:
      hashedPostalCode || undefined,

    sha256_hashed_street:
      hashedStreet || undefined,

    sha256_hashed_country:
      hashedCountry || undefined
  };

  window.dataLayer.push({
    event: 'submit_application_form',
    user_data: userData
  });

  window.dataLayer.push({
    user_data: null
  });
}

/**
 * Handles the final form submission.
 *
 * ApplicationFormCompleted fires once after Zoho returns
 * a successful HTTP response.
 */
async function handleFormSubmit(event) {
  event.preventDefault();

  if (!form) return;

  const registeredCompany = document.querySelector(
    'input[name="registered_company_radio"]:checked'
  );

  const submitButton = document.querySelector(
    '#pro-form-submit'
  );

  const formContainer = document.querySelector(
    '.pro-form'
  );

  const thankYouPage = document.getElementById(
    'thankYouPage'
  );

  const formData = new FormData(form);

  if (
    qualification?.value ===
    'Other (please specify)'
  ) {
    const alternativeQualification = document
      .getElementById('altQual')
      ?.value.trim();

    if (alternativeQualification) {
      formData.set(
        'LEADCF7',
        alternativeQualification
      );
    }
  }

  formData.delete('altQual');

  const allStepsValid = [
    [
      'First_Name',
      'Last_Name',
      'Email',
      'Confirm_Email',
      'Phone'
    ],
    [
      'Company',
      'LEADCF3',
      'LEADCF29',
      'LEADCF5',
      'LEADCF9',
      'Street',
      'City',
      'State',
      'Zip_Code',
      'LEADCF8',
      'LEADCF11',
      'LEADCF12',
      'LEADCF13',
      'LEADCF14',
      'LEADCF15',
      'No_of_Employees',
      'Address_Confirm',
      'LEADCF30'
    ],
    [
      'Website',
      'LEADCF10',
      'LEADCF27',
      'LEADCF23',
      'LEADCF26'
    ],
    [
      'LEADCF7',
      'altQual',
      'LEADCF20',
      'docUpload'
    ]
  ].every(fields => validateSimple(fields));

  if (!allStepsValid) {
    window.scrollTo({
      top: 95,
      behavior: 'smooth'
    });

    return;
  }

  [...form.elements].forEach(element => {
    if (
      !element.name ||
      element.type === 'submit'
    ) {
      return;
    }

    const value = element.value?.trim();
    const shouldRemove =
      !value ||
      value === '---';

    if (
      shouldRemove &&
      formData.has(element.name)
    ) {
      formData.delete(element.name);
    }
  });

  submitButton?.classList.add('loading');

  if (submitButton) {
    submitButton.disabled = true;
  }

  if (
    registeredCompany?.value === 'Yes'
  ) {
    formData.set('LEADCF102', 'on');
  }

  if (phoneVerify?.isValidNumber()) {
    formData.set(
      'Phone',
      phoneVerify.getNumber()
    );
  }

  if (!formData.get('No of Employees')) {
    formData.set('No of Employees', '0');
  }

  const files1 = droppedFiles
    ? Array.from(droppedFiles)
    : Array.from(
        document.getElementById('docUpload')?.files || []
      );

  const files2 = droppedFiles2
    ? Array.from(droppedFiles2)
    : Array.from(
        document.getElementById('docUpload2')?.files || []
      );

  const allFiles = [
    ...files1,
    ...files2
  ];

  formData.delete('theFile');
  formData.delete('theFile2');

  allFiles.forEach(file => {
    formData.append('theFile', file);
  });

  if (
    typeof _wfa_track !== 'undefined' &&
    typeof _wfa_track.wfa_submit === 'function'
  ) {
    _wfa_track.wfa_submit(event);
  }

  try {
    const response = await fetch(
      'https://crm.zoho.eu/crm/WebToLeadForm',
      {
        method: 'POST',
        body: formData,
        cache: 'no-cache'
      }
    );

    await response.text();

    if (!response.ok) {
      throw new Error(
        `Submission failed (${response.status})`
      );
    }

    // Notify advertising integrations only after Zoho accepts the submission.
    document.dispatchEvent(new CustomEvent('pro:application-submitted'));

    /*
     * These functions read values and files from the active form,
     * so they must run before the form is reset.
     */
    await dataLayerFormSubmit();
    webhookAirParser();

    if (!applicationFormCompletedTracked) {
      const eventSent = publishMetaEvent(
        'trackCustom',
        'ApplicationFormCompleted',
        {
          form_name: 'Pro Application Form',
          form_id: 'pro-form'
        }
      );

      if (eventSent) {
        applicationFormCompletedTracked = true;
      }
    }

    submitButton?.classList.remove('loading');

    if (formContainer) {
      formContainer.style.display = 'none';
    }

    if (thankYouPage) {
      thankYouPage.style.display = 'flex';
    }

    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });

    form.reset();
    clearFiles();
    clearFiles2();

    current = 0;
    updateStep();
    clearSavedFormData();
  } catch (error) {
    console.error(
      'Application form submission failed:',
      error
    );

    submitButton?.classList.remove('loading');

    if (submitButton) {
      submitButton.disabled = false;
    }

    alert(
      `An error occurred: ${error.message}`
    );
  }
}